
import React from "react";

class Loading extends React.Component {
  render() {
    return (
      <div className="login-overlay">
        <div className="spinner"></div>
        <h2>Loading UrbanAware System...</h2>
      </div>
    );
  }
}

export default Loading;
